<app-version-banner></app-version-banner>

<div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;" *ngIf="loading === true">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
  <p class="loading">Assessment Planner</p>
</div>

<ng-container *ngIf="loading !== true">
  <router-outlet></router-outlet>
  <p-confirmDialog></p-confirmDialog>
  <p-toast key="toast" position="top-center"></p-toast>
  <app-modal-spinner></app-modal-spinner>
</ng-container>
